import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class UmQuesFormV2 extends HTMLElement {
   constructor() {
      super();
      // this.attachShadow({ mode: 'open' });
      this.loading = false
      this.index = 0
      this.maxQues = this.querySelectorAll('.ques-item').length
      this.id = this.getAttribute('id')

      this.ans_data = []

      this.client_name = this.querySelector('input[name="client_name"]')
      this.submitBtn = this.querySelector('.ques-item--submit um-button')

      this.el_cb = this.querySelector('.ques-callback')

      gsap.set(this.el_cb, { height: 0, opacity: 0 })

      this.updateQuesHeight()

   }

    connectedCallback() {
      window.addEventListener('resize', () => {
        this.updateQuesHeight()
      });

      this.querySelectorAll('input[type="radio"]').forEach((item, i) => {
        item.addEventListener('change', (e) => {
          this.ans_data.push({
            ques: {
              id: e.target.dataset.quesId,
              title: e.target.dataset.quesTitle,
            },
            ans: {
              id: e.target.dataset.choiceId,
              title: e.target.value,
            }
          })

          // console.log(this.data);
          this.changeIndex(this.index + 1)
        })
      });

      this.querySelectorAll('.ques-item--next um-button').forEach((item, i) => {
        item.clickEvent = () => {
          this.ans_data.push({
            ques: {
              id: item.dataset.quesId,
              title: item.dataset.quesTitle,
            },
            ans: {
              id: item.dataset.quesId,
              title: this.querySelector(`.ques-item--input input[name="${item.dataset.quesSlug}"]`).value,
            }
          })

          console.log(this.data);
          this.changeIndex(this.index + 1)
        }
      });

      this.submitBtn.clickEvent = () => {
        this.handleSubmit()
      }
    }

    changeIndex(index) {
      switch (index) {
        case 'final':

          break;
        default:
          if (index < this.maxQues) {
            this.index = index
            this.querySelector('.ques-items').style.setProperty('--index', this.index)
            this.updateQuesHeight()
          } else {
            this.handleSubmit()
          }
      }

    }

    updateQuesHeight() {
      switch (this.index) {
        case 'final':
          // let h = this.el_cb.offsetHeight
          // gsap.to(this.querySelector('.ques-slider'), {
          //   height: h
          // })
          break;
        default:
          let h = 0
          this.querySelectorAll('.ques-item').forEach((item, i) => {
            if (item.getBoundingClientRect().height > h) {
              h = item.getBoundingClientRect().height
            }
          });

          // let h = this.querySelectorAll('.ques-item')[this.index].getBoundingClientRect().height
          gsap.to(this.querySelectorAll('.ques-slider'), {
            height: `${Math.ceil(h)}px`,
            onComplete: () => {
              ScrollTrigger.refresh()
            }
          })
          break;
      }
    }

    handleSubmit() {
      // console.log(this.textarea.value);
      if (this.loading) {
        return
      }

      let client_name = ''
      if (this.client_name && this.client_name.value) {
        client_name = this.client_name.value
      } else {
        return
      }

      let post_data = {
        ques: this.id,
        client_name: client_name,
        ans_data: this.ans_data
      }

      this.loading = true
      const url = `${window.location.origin}${window.location.pathname}?api=quesAns`
      // const url = `${root}${lang}?api=quesAns`

      gsap.to(this.querySelector('.ques-form'), {
        height: 0,
        opacity: 0,
      })

      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(post_data),
      })
      .then(response => response.text())
      .then((data) => {
        const res = JSON.parse(data)

        if (res.code == 200) {
          let cbWrap = this.querySelector('.ques-callback--wrap')


          let new_html = document.createElement("div");
          new_html.innerHTML = res.callback.trim();
          cbWrap.appendChild(new_html.firstChild)
          // window.scrollTo(0, this.el_cb.getBoundingClientRect().top + window.scrollY)

          if (window.innerWidth <= 768) {
            gsap.set(this.el_cb, { minHeight: '100vh' })
            window.scrollTo({
              left: 0,
              top: this.el_cb.getBoundingClientRect().top + window.scrollY,
              behavior: "smooth",
            })
          }

          gsap.to(this.el_cb, {
            height: 768,
            opacity: 1,
            onComplete: () => {
              this.index = 'final'
              gsap.set(this.el_cb, { height: 'auto' })

              ScrollTrigger.refresh()
            }
          })
        }


      });


    }

}

customElements.define('um-ques-form-v2', UmQuesFormV2);
